import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { BaseTableContainer } from './style';
import { Box, Tooltip, Typography } from '@mui/material';
import { IElement } from 'lib/common/types';
import { brand } from 'themes/brand';

interface ITableBody {
  name: string;
  company: string;
  sectors: IElement[];
  user?: string;
  actions: JSX.Element;
}

const StyledTableCell: any = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: brand.tint,
    color: brand.text,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  '&:nth-of-type(odd)': {
    backgroundColor: brand.white,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export default function CustomizedTable(props: {
  tableHead: string[];
  tableBody: ITableBody[];
}) {
  return (
    <BaseTableContainer>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            {props.tableHead.map((item, index) => (
              <StyledTableCell key={index}>{item}</StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {props.tableBody.map((item, index) => {
            return (
              <StyledTableRow key={index}>
                <StyledTableCell align="left">
                  <Tooltip title={item.name} placement="top-start">
                    <Typography>
                      {item.name.length > 20
                        ? `${item.name.substring(0, 20)}...`
                        : item.name}
                    </Typography>
                  </Tooltip>
                </StyledTableCell>

                <StyledTableCell align="left">{item.company}</StyledTableCell>
                <StyledTableCell align="left" style={{ width: '150px' }}>
                  {item.sectors.map((el) => (
                    <Box>{el.name}</Box>
                  ))}
                </StyledTableCell>
                <StyledTableCell align="left">{item.user}</StyledTableCell>
                <StyledTableCell align="right">{item.actions}</StyledTableCell>
              </StyledTableRow>
            );
          })}
        </TableBody>
      </Table>
    </BaseTableContainer>
  );
}
